import type { BookSalesResponse } from "reedy-data/api";
import type { Granularity } from "~/components/charts";
import { useSalesQuery } from "./use-sales-query";

export const useMarketSales = (
  isbns: string[] | undefined,
  initialGranularity?: Granularity,
) => useSalesQuery<BookSalesResponse>(isbns, "market", initialGranularity);
